//用户管理
export default [
  {
    path: '/familyManage',
    component: () => import('../pages/userManage/familyManage.vue'),
    name: 'familyManage',
    title: '家庭管理',
    meta: {
      title: '家庭管理',
    },
  },
  {
    path: '/complainManage',
    component: () => import('../pages/userManage/complainManage.vue'),
    name: 'ComplainManage',
    title: '投诉建议',
    meta: {
      title: '投诉建议',
    },
  },
  {
    path: '/propertyserve',
    component: () => import('../pages/userManage/propertyServe.vue'),
    name: 'PropertyServe',
    title: '物业服务',
    meta: {
      title: '物业服务',
    },
  },
  {
    path: '/userMesManage',
    component: () => import('../pages/userManage/userMesManage.vue'),
    name: 'UserMesManage',
    title: '会员信息',
    meta: {
      title: '会员信息',
    },
  },
  {
    path: '/userStaffMesManage',
    component: () => import('../pages/userManage/userStaffMesManage.vue'),
    name: 'UserStaffMesManage',
    title: '员工会员信息',
    meta: {
      title: '员工会员信息',
    },
  },
  {
    path: '/employeeInviteLog',
    component: () => import('../pages/userManage/employeeInviteLog.vue'),
    name: 'employeeInviteLog',
    title: '员工邀约记录',
    meta: {
      title: '员工邀约记录',
    },
  },
  {
    path: '/userAuthManage',
    component: () => import('../pages/userManage/userAuthManage.vue'),
    name: 'userAuthManage',
    title: '用户门锁授权管理',
    meta: {
      title: '用户门锁授权管理',
    },
  },
  {
    path: '/couponFeeManage',
    component: () => import('../pages/userManage/couponFeeManage.vue'),
    name: 'userAuthManage',
    title: '赠送卡券管理',
    meta: {
      title: '赠送卡券管理',
    },
  },
  {
    path: '/userAnalyse',
    component: () => import('../pages/userManage/userAnalyse.vue'),
    name: 'userAnalyse',
    title: '用户画像',
    meta: {
      title: '用户画像',
    },
  },
  {
    path: '/butlerManage',
    component: () => import('../pages/userManage/butlerManage.vue'),
    name: 'butlerManage',
    title: '配置管家',
    meta: {
      title: '配置管家',
    },
  },
]
